// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-to-home-modal {
  width: 100vw;
}
.add-to-home-modal .modal-center {
  width: 100vw;
  max-width: 500px;
  margin: 0;
  border-radius: 24px;
  background: #fff;
}
.add-to-home-modal .ant-modal-content {
  border-radius: 16px 16px 16px 16px;
  padding: 24px;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
}
.add-to-home-modal .ant-modal {
  pointer-events: none;
}
.add-to-home-modal .ant-modal-content {
  pointer-events: auto;
}
.add-to-home-modal .modal-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.add-to-home-modal .modal-body h2 {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #00aa74;
  font-weight: bold;
}
.add-to-home-modal .modal-body p {
  margin-bottom: 16px;
  font-size: 14px;
  color: #00aa74;
  line-height: 1.4;
}
.add-to-home-modal .modal-body ol {
  width: 100%;
  text-align: left;
  font-size: 14px;
  margin-bottom: 20px;
  padding-left: 20px;
}
.add-to-home-modal .modal-body ol li {
  margin-bottom: 8px;
  color: #00aa74;
  line-height: 1.4;
}
.add-to-home-modal .modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.add-to-home-modal .modal-battery {
  width: 80px;
  margin-bottom: 1rem;
}
.add-to-home-modal .modal-logo {
  width: 40px;
  margin-bottom: 0.5rem;
}
.add-to-home-modal .modal-heading {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.add-to-home-modal .modal-subheading {
  font-size: 14px;
  color: #666;
  margin-bottom: 1rem;
}
.add-to-home-modal .modal-instructions {
  width: 100%;
  text-align: left;
  font-size: 14px;
  margin-bottom: 1rem;
}
.add-to-home-modal .modal-instructions ol {
  padding-left: 1rem;
}
.add-to-home-modal .modal-instructions ol li {
  margin-bottom: 0.5rem;
  color: #00aa74;
  line-height: 1.4;
}
.add-to-home-modal .modal-button {
  width: 100%;
  background-color: #00b050;
  color: white;
  font-weight: 600;
  padding: 14px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/Views/AfterAuth/Modal/AddToHomeModal.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;AAAI;EACI,YAAA;EACA,gBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAER;AACI;EACI,kCAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;AACR;AAEI;EACI,oBAAA;AAAR;AAGI;EACI,oBAAA;AADR;AAII;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAFR;AAIQ;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAFZ;AAKQ;EACI,mBAAA;EACA,eAAA;EAEA,cAAA;EACA,gBAAA;AAJZ;AAOQ;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AALZ;AAMY;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AAJhB;AASI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAPR;AAUI;EACI,WAAA;EACA,mBAAA;AARR;AAWI;EACI,WAAA;EACA,qBAAA;AATR;AAYI;EACI,eAAA;EACA,gBAAA;EACA,sBAAA;AAVR;AAaI;EACI,eAAA;EACA,WAAA;EACA,mBAAA;AAXR;AAcI;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AAZR;AAcQ;EACI,kBAAA;AAZZ;AAcY;EACI,qBAAA;EACA,cAAA;EACA,gBAAA;AAZhB;AAiBI;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAfR","sourcesContent":[".add-to-home-modal {\n    width: 100vw;\n    .modal-center {\n        width: 100vw;\n        max-width: 500px;\n        margin: 0;\n        border-radius: 24px;\n        background: #fff;\n    }\n\n    .ant-modal-content {\n        border-radius: 16px 16px 16px 16px;\n        padding: 24px;\n        background-color: #fff;\n        box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);\n    }\n\n    .ant-modal {\n        pointer-events: none;\n    }\n\n    .ant-modal-content {\n        pointer-events: auto;\n    }\n\n    .modal-body {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n\n        h2 {\n            margin-bottom: 12px;\n            font-size: 18px;\n            font-weight: 600;\n            color: #00aa74;\n            font-weight: bold;\n        }\n\n        p {\n            margin-bottom: 16px;\n            font-size: 14px;\n            // color: #666;\n            color: #00aa74;\n            line-height: 1.4;\n        }\n\n        ol {\n            width: 100%;\n            text-align: left;\n            font-size: 14px;\n            margin-bottom: 20px;\n            padding-left: 20px;\n            li {\n                margin-bottom: 8px;\n                color: #00aa74;\n                line-height: 1.4;\n            }\n        }\n    }\n\n    .modal-content {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        text-align: center;\n    }\n\n    .modal-battery {\n        width: 80px;\n        margin-bottom: 1rem;\n    }\n\n    .modal-logo {\n        width: 40px;\n        margin-bottom: 0.5rem;\n    }\n\n    .modal-heading {\n        font-size: 18px;\n        font-weight: 600;\n        margin-bottom: 0.25rem;\n    }\n\n    .modal-subheading {\n        font-size: 14px;\n        color: #666;\n        margin-bottom: 1rem;\n    }\n\n    .modal-instructions {\n        width: 100%;\n        text-align: left;\n        font-size: 14px;\n        margin-bottom: 1rem;\n\n        ol {\n            padding-left: 1rem;\n\n            li {\n                margin-bottom: 0.5rem;\n                color: #00aa74;\n                line-height: 1.4;\n            }\n        }\n    }\n\n    .modal-button {\n        width: 100%;\n        background-color: #00b050;\n        color: white;\n        font-weight: 600;\n        padding: 14px;\n        border-radius: 8px;\n        border: none;\n        cursor: pointer;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
